import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {isOutputValid} from "../../../ClassicFunctions";
import ClassicOutputNotice from "../../../ClassicOutputNotice";
import {OutputAddButtonTooltip} from "../../../Tooltips/OutputAddButtonTooltip";

class Output extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const {addSubField, group, premium} = this.props;

		let fields = [
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'ID', 'Post ID' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_title', 'Post title' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_author', 'Post author' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_date', 'Post date' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_date_gmt', 'Post date GMT' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_content', 'Post content' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_excerpt', 'Post excerpt' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_status', 'Post status' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'comment_status', 'Comment status' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'ping_status', 'Ping status' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_password', 'Post password' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_name', 'Post name' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'to_ping', 'To ping' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'pinged', 'Pinged' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_modified', 'Post modified' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_modified_gmt', 'Post modified GMT' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_content_filtered', 'Post content filtered' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_parent', 'Post parent' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'guid', 'GUID' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'permalink', 'Permalink' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'menu_order', 'Menu order' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_type', 'Post type' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_mime_type', 'Post mime type' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'comment_count', 'Comment count' ),
      getFieldFactory().getNewDefaultFieldGroupForOutput( 'post_format', 'Post format' ),

			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_ID', 'Parent post: Post ID' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_title', 'Parent post: Post title' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_author', 'Parent post: Post author' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_date', 'Parent post: Post date' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_date_gmt', 'Parent post: Post date GMT' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_content', 'Parent post: Post content' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_excerpt', 'Parent post: Post excerpt' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_status', 'Parent post: Post status' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_comment_status', 'Parent post: Comment status' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_ping_status', 'Parent post: Ping status' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_password', 'Parent post: Post password' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_name', 'Parent post: Post name' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_to_ping', 'Parent post: To ping' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_pinged', 'Parent post: Pinged' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_modified', 'Parent post: Post modified' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_modified_gmt', 'Parent post: Post modified GMT' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_content_filtered', 'Parent post: Post content filtered' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_parent', 'Parent post: Post parent' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_guid', 'Parent post: GUID' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_permalink', 'Parent post: Permalink' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_menu_order', 'Parent post: Menu order' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_type', 'Parent post: Post type' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_mime_type', 'Parent post: Post mime type' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_comment_count', 'Parent post: Comment count' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_post_format', 'Parent post: Post format' ),

			{
				name:   'parent_custom-field',
				label:  'Parent post: Custom field',
				fields: [
					{
						id:        'customFieldName',
						inputType: 'input',
						value:     '',
						label:     'Custom field name',
						dynamic:   false,
					},
				],
			},
			{
				name:   'custom-field',
				label:  'Custom field',
				fields: [
					{
						id:        'customFieldName',
						inputType: 'input',
						value:     '',
						label:     'Custom field name',
						dynamic:   false,
					},
          {
            id:        'customFieldNameDisplay',
            inputType: 'input',
            value:     '',
            label:     'Custom field name display',
            dynamic:   false,
          },
				],
			},
			{
				name:   'custom-field-toolset',
				label:  'Custom field (Toolset Types)',
				fields: [
					{
						id:        'customFieldName',
						inputType: 'input',
						value:     '',
						label:     'Custom field name',
						dynamic:   false,
					},
					{
						id:        'customFieldFormat',
						inputType: 'input',
						value:     '',
						label:     'Format',
						dynamic:   false,
					},
				],
			},
			{
				name: 'taxonomy',
				label: 'Taxonomy',
				fields: [
					{
						id: 'taxonomy',
						inputType: 'select',
						source: 'taxonomies',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Taxonomy',
						defaultValue: 'Select a taxonomy',
						dynamic: false
					},
					{
						id: 'field-type',
						inputType: 'checkboxes',
						source: 'termFieldTypes',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Fields',
						defaultValue: 'Select a field type',
						dynamic: false
					},
					{
						id:        'termFields',
						inputType: 'input',
						value:     '',
						label:     'Term fields (separated by comma)',
						dynamic:   false,
					},
				],
			},

			{
				name: 'parent_taxonomy',
				label: 'Parent post: Taxonomy',
				fields: [
					{
						id: 'taxonomy',
						inputType: 'select',
						source: 'taxonomies',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Taxonomy',
						defaultValue: 'Select a taxonomy',
						dynamic: false
					},
					{
						id: 'field-type',
						inputType: 'checkboxes',
						source: 'termFieldTypes',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Fields',
						defaultValue: 'Select a field type',
						dynamic: false
					},
					{
						id:        'termFields',
						inputType: 'input',
						value:     '',
						label:     'Term fields (separated by comma)',
						dynamic:   false,
					},
				],
			},

			getFieldFactory().getNewDefaultFieldGroupForOutput( 'featured_image', 'Featured image' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'attached_images', 'Attached images' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'attached_audios', 'Attached audios' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'attached_videos', 'Attached videos' ),

			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_featured_image', 'Parent post: Featured image' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_attached_images', 'Parent post: Attached images' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_attached_audios', 'Parent post: Attached audios' ),
			getFieldFactory().getNewDefaultFieldGroupForOutput( 'parent_attached_videos', 'Parent post: Attached videos' ),
		];

		fields = fields.map(field => {
			field.fields = [...field.fields, ...getFieldFactory().getExtraFields()];
			return field;
		});

		return (
			<React.Fragment>
				<FieldGroupContext.Consumer>

					{({ endpointId, endpoint, currentItem, action }) => (<React.Fragment>
						<h3>Fields to display in the output: ({endpoint.displayData[currentItem].output.length})</h3>

						Select a field to output: <select className="display-data-output-selector" value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
							{fields.sort((a, b) => (a.label > b.label) ? 1 : -1).map((el, index) => <option key={index} value={el.name}>{el.label}</option>)}
						</select>

            <OutputAddButtonTooltip
              button={<button
                onClick={() => (premium || isOutputValid(endpoint.displayData[currentItem].output.length)) && addSubField(endpointId, fields.filter(el => el.name === this.state.selectedFilterToAdd), currentItem, group, action)}
                disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
                className="button-secondary"
              >
                Add field
              </button>}
            />

            <ClassicOutputNotice />

						<FieldGroups group={group} />

					</React.Fragment>)}
				</FieldGroupContext.Consumer>
			</React.Fragment>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Output);
